
    <div class="vs-space-setups" [class.hide-tooltip]="!showTooltip">
      <div *ngFor="let setup of setups" class="space-setup" [mdl-tooltip]="'SETUPS.'+setup.label.toUpperCase() | translate" mdl-tooltip-position="bottom">
        <i class="icon" [ngClass]="getSetupIcon(setup.label)"></i>
        <span *ngIf="showLabel" class="space-setup-name">{{ ('SETUPS.'+setup.label.toUpperCase()) | translate }}</span>
        <span class="space-setup-number">{{ setup.max }}</span>
      </div>
    </div>
  